
export const resetEditWorkerReducer = (state) => {
    state.editWorker.status = "idle";
    state.editWorker.errorMessage = "";
  }